import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import "./config";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { CartProvider } from "./contexts/CartContext";
import { AccountProvider } from "./contexts/AccountContext";
import { WishlistProvider } from "./contexts/WishlistContext";
import { InformationProvider } from "./contexts/InformationContext";
import "typeface-lora";
import { ReviewCenterProvider } from "./contexts/ReviewCenterContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <CartProvider>
      <AccountProvider>
        <ReviewCenterProvider>
          <WishlistProvider>
            <InformationProvider>
              <GoogleOAuthProvider
                className="my-auto"
                clientId="56926846264-uch49najl2q2e3tgr1vn142iujg529pn.apps.googleusercontent.com"
              >
                <App />
              </GoogleOAuthProvider>
            </InformationProvider>
          </WishlistProvider>
        </ReviewCenterProvider>
      </AccountProvider>
    </CartProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
